// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__wyL8R","copyright":"footer_copyright__1d49E","logo_container":"footer_logo_container__iFdvC"};